<div class="shipping-container">
  @if (isLoadingShippingAddress$ | async) {
  <pbb-loading-overlay
    [titleKey]="'CHECKOUT.SHIPPING_OPTIONS.CHECKING_TITLE'"
    [subtitleKey]="'CHECKOUT.SHIPPING_OPTIONS.CHECKING_SUBTITLE'"
  ></pbb-loading-overlay>
  } @else {
  <div class="content_main-container">
    <div class="flex-row flex-full-width">
      <h1>{{ 'COMMON.CREATE_PROFILE.CHOOSE_SHIPPING_ADDRESS.TITLE' | translate }}</h1>
      <div class="content_main-button-list">
        <a
          class="mb-8"
          [routerLink]="['/checkout/address/edit-merchant']"
          [state]="{
            isEdit: false,
            continueToShipping: true
          }"
          id="add_new_address_btn"
          [title]="'COMMON.VIEW_ADDRESS.BUTTON_ADD_ADDRESS' | translate"
        >
          <pbb-svg-icon
            [icon]="'add-btn'"
            [title]="'COMMON.VIEW_ADDRESS.BUTTON_ADD_ADDRESS' | translate"
            class="icon-md"
          ></pbb-svg-icon>
        </a>
      </div>
    </div>

    <ng-container *ngrxLet="merchantAddresses$ as merchantAddresses">
      @if (merchantAddresses && merchantAddresses.length > 0) {
      <p class="addresses-from-merchant">
        {{ 'CHECKOUT.SHARED.ADDRESSES_FROM' | translate : { merchantName: (merchantName$ | async) } }}
      </p>

      <pbb-address-list
        [addresses]="merchantAddresses"
        [showMenuButton]="false"
        [selectable]="true"
        [defaultShippingAddressRef]="getMerchantDefaultRef(merchantAddresses)"
        [selectedShippingAddressRef]="(selectedShippingAddress$ | async)?.shipping_address_ref"
        (clickShippingAddress)="onAddressSelect($event)"
        [addressTitleKey]="'CHECKOUT.SHARED.SHIP_TO'"
      ></pbb-address-list>
      }
    </ng-container>

    <ng-container *ngrxLet="userAddresses$ as userAddresses">
      @if (userAddresses && userAddresses.length > 0) {
      <p class="addresses-from-konek">{{ 'COMMON.YOUR_SAVED_ADDRESSES' | translate }}</p>

      <ng-container *ngrxLet="userDefaultAddressRef$ as userDefaultAddressRef">
        <pbb-address-list
          [addresses]="userAddresses"
          [showMenuButton]="false"
          [selectable]="true"
          [defaultShippingAddressRef]="userDefaultAddressRef"
          [selectedShippingAddressRef]="(selectedShippingAddress$ | async)?.shipping_address_ref"
          (clickShippingAddress)="onAddressSelect($event)"
          [addressTitleKey]="'CHECKOUT.SHARED.SHIP_TO'"
        ></pbb-address-list>
      </ng-container>
      }
    </ng-container>
  </div>

  <div appStickyButton="#footer" class="sticky-container">
    <div class="sticky-main">
      <ng-container *ngrxLet="selectedShippingAddress$ as selectedAddress">
        <ng-container *ngrxLet="isLoadingShippingAddress$ as isLoading">
          <pbb-button
            [size]="'L'"
            id="btn-continue"
            [disabled]="!selectedAddress?.shipping_address_ref || isLoading"
            (clicked)="onContinueClick()"
          >
            {{ 'COMMON.BUTTON.CONTINUE' | translate }}
          </pbb-button>
        </ng-container>
      </ng-container>
      <p class="footer-subtitle">{{ 'COMMON.YOU_CAN_CHANGE_THIS_ANYTIME' | translate }}</p>
    </div>
  </div>
  }
</div>
